export interface SignUpFields {
  firstName: string;
  email: string;
  password: string;
  confirmPassword: string;
  sector: string;
  termsAccepted: boolean;
  privacyAccepted: boolean;
}

// Letters (including accented), spaces, hyphens, apostrophes only
const PLAIN_NAME_RE = /^[\p{L}\s'\-]+$/u;

// No whitespace, quotes, or multiple @ signs; requires at least one dot in the domain
const EMAIL_RE = /^[^\s@"]+@[^\s@.]+(\.[^\s@.]+)+$/;

// Rejects quoted local-parts, multiple @, and dangerous HTML characters
function validateEmail(raw: string): string | null {
  const email = raw.trim();
  if (!email) return 'Email is required';
  if (email.length > 254) return 'Email address is too long';
  if (/[<>&"]/.test(email)) return 'Email address contains invalid characters';
  if (!EMAIL_RE.test(email)) return 'Please enter a valid email address';
  return null;
}

export function validateSignUp(fields: SignUpFields): string | null {
  const {
    firstName,
    email,
    password,
    confirmPassword,
    sector,
    termsAccepted,
    privacyAccepted,
  } = fields;

  if (!firstName.trim()) return 'First name is required';
  if (firstName.trim().length > 50)
    return 'First name must be 50 characters or fewer';
  if (!PLAIN_NAME_RE.test(firstName.trim()))
    return 'First name may only contain letters, spaces, hyphens, and apostrophes';

  const emailError = validateEmail(email);
  if (emailError) return emailError;

  if (!password) return 'Password is required';
  if (password.length < 8) return 'Password must be at least 8 characters';
  if (password.length > 72) return 'Password must be 72 characters or fewer';
  if (!/[A-Z]/.test(password))
    return 'Password must include an uppercase letter';
  if (!/[a-z]/.test(password))
    return 'Password must include a lowercase letter';
  if (!/[0-9]/.test(password)) return 'Password must include a number';
  if (confirmPassword !== password) return "Passwords don't match";

  if (!sector) return 'Please select your sector';
  if (!termsAccepted) return 'You must accept the Terms of Service';
  if (!privacyAccepted) return 'You must accept the Privacy Policy';

  return null;
}
